// removed by extract-text-webpack-plugin
module.exports = {"popoverZIndex":"19","popoverOZIndex":"21","divider":"Cart__divider___2qWHd","gm-style-iw":"Cart__gm-style-iw___I4UCg","root":"Cart__root___2rKki","cartPageContainer":"Cart__cartPageContainer___1PoZs","sumBlock":"Cart__sumBlock___1G85W","submitBtn":"Cart__submitBtn___2Cm98","cartPageHeader":"Cart__cartPageHeader___1eVmS"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Cart/Cart.scss
 ** module id = 1230
 ** module chunks = 0
 **/